import styled from "styled-components";

const StatusIcon = styled.svg`
  width: 20px;
  height: 20px;
  fill: ${({ color }) => color};
`;

const ChipIcon = ({ color, status }) =>
  status !== "danger" ? (
    <StatusIcon
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2083 3.125C6.41099 3.125 3.33325 6.20274 3.33325 10C3.33325 13.7965 6.41104 16.875 10.2083 16.875C14.0055 16.875 17.0833 13.7965 17.0833 10C17.0833 6.20274 14.0055 3.125 10.2083 3.125ZM2.08325 10C2.08325 5.51239 5.72064 1.875 10.2083 1.875C14.6958 1.875 18.3333 5.51239 18.3333 10C18.3333 14.4867 14.6959 18.125 10.2083 18.125C5.72059 18.125 2.08325 14.4867 2.08325 10Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.536 7.63423C13.78 7.87831 13.78 8.27403 13.536 8.51808L9.68783 12.3663C9.44383 12.6103 9.04817 12.6103 8.80408 12.3663L6.8792 10.4423C6.63507 10.1983 6.63498 9.8025 6.87901 9.55842C7.12304 9.31425 7.51877 9.31417 7.76289 9.55817L9.24583 11.0405L12.6521 7.63423C12.8962 7.39015 13.2919 7.39015 13.536 7.63423Z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </StatusIcon>
  ) : (
    <StatusIcon
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <g clipPath="url(#clip0)">
        <path
          fill="#EC2D30"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2083 3.125C6.41099 3.125 3.33325 6.20274 3.33325 10C3.33325 13.7965 6.41104 16.875 10.2083 16.875C14.0055 16.875 17.0833 13.7965 17.0833 10C17.0833 6.20274 14.0055 3.125 10.2083 3.125ZM2.08325 10C2.08325 5.51239 5.72064 1.875 10.2083 1.875C14.6958 1.875 18.3333 5.51239 18.3333 10C18.3333 14.4867 14.6959 18.125 10.2083 18.125C5.72059 18.125 2.08325 14.4867 2.08325 10Z"
        />
        <path
          d="M7.5 6.5C7.22386 6.22386 6.77614 6.22386 6.5 6.5C6.22386 6.77614 6.22386 7.22386 6.5 7.5L9.5 10.5L6.5 13.5C6.22386 13.7761 6.22386 14.2239 6.5 14.5C6.77614 14.7761 7.22386 14.7761 7.5 14.5L10.5 11.5L13.5 14.5C13.7761 14.7761 14.2239 14.7761 14.5 14.5C14.7761 14.2239 14.7761 13.7761 14.5 13.5L11.5 10.5L14.5 7.5C14.7761 7.22386 14.7761 6.77614 14.5 6.5C14.2239 6.22386 13.7761 6.22386 13.5 6.5L10.5 9.5L7.5 6.5Z"
          fill="#EC2D30"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="20" fill="#EC2D30" />
        </clipPath>
      </defs>
    </StatusIcon>
  );

export default ChipIcon;
